import { QuoteStatusChangeSearchRequestParams, QuoteStatusChangeSearchResponse } from '@lio/api-types';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useSearchQuoteStatusChange = ({
  quoteId,
  pageLimit,
  sort,
}: QuoteStatusChangeSearchRequestParams & {
  pageOffset?: number | undefined;
  pageLimit?: number | undefined;
  sort?: string | undefined;
}) => {
  const queryParams = new URLSearchParams();
  if (pageLimit) {
    queryParams.append('pageLimit', pageLimit.toString());
  }
  if (sort) {
    queryParams.append('sort', sort.toString());
  }

  const client = useClient();
  const result = useInfiniteQuery<QuoteStatusChangeSearchResponse, Error>({
    queryKey: ['status-change', { quoteId }],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await client
        .get(`quote/${quoteId}/status-change?${queryParams.toString()}&pageOffset=${pageParam}`)
        .json<QuoteStatusChangeSearchResponse>();
      return response;
    },
    enabled: Boolean(quoteId),
    initialPageParam: 0,
    placeholderData: (previousData) => previousData,
    staleTime: 15000,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage?.pagination) return undefined;
      if (!lastPage.pagination.pageLimit) return undefined;
      if (!lastPage.pagination.total) return undefined;
      const { total, pageLimit } = lastPage.pagination;
      const fetchedPageCount = allPages.length;
      const nextPageOffsetValue = fetchedPageCount * pageLimit;
      if (nextPageOffsetValue > total) return undefined;
      return nextPageOffsetValue;
    },
  });
  return { ...result, quoteStatusChange: result.data };
};
